import React from 'react';
import RouteMonitor from './RouteMonitor';

export default function Reports(props) {
  return (
    <RouteMonitor
      {...props}
      mode="reports"
      initialTab="history"
      allowedTabs={['history', 'balance', 'settings']}
    />
  );
}
